import { createFileRoute } from '@tanstack/react-router'
import EanSeriesContainer from 'Administration/containers/EanSeriesContainer'

import AdministrationPage from '../-administrationPage'
import { Guard } from '../-guard'

export const Route = createFileRoute('/administration/eanseries')({
    component: () => (
        <Guard claims={['opus_user']}>
            <AdministrationPage>
                <EanSeriesContainer />
            </AdministrationPage>
        </Guard>
    ),
})
